const CLEAR_SELECTION = '<clear-selection>';
export default CLEAR_SELECTION;
